import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import { TrendingUp, Menu, X, PieChart, Disc } from 'react-feather'
import { BasicLink } from '../Link'
import { MENU_LINKS } from '../../constants'
import MobileMenu from '../MobileMenu'

const Container = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  z-index: 9999;
  height: 64px;
  width: 100%;
  background-color: ${({ theme }) => theme.black};
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  padding: 0px 65px;
  justify-content: space-between;
  box-sizing: border-box;

  @media (max-width: 550px) {
    padding: 30px;
  }
`

const FooterMenuOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: white;
  opacity: 0.7;
  font-size: 10px;

  :hover {
    opacity: 1;
    cursor: pointer;
  }
`

const menuLinks = [
  { ...MENU_LINKS['HOME'], icon: <TrendingUp size={18} /> },
  { ...MENU_LINKS['TOKENS'], icon: <Disc size={18} /> },
  { ...MENU_LINKS['PAIRS'], icon: <PieChart size={18} /> },
  // Referral program removed
  // { ...MENU_LINKS['AFFILIATE'], icon: <DollarSign size={18} /> },
]

const NavigationListTablet = ({ menuLinks, history, setMenuOpen, menuOpen, searchBarVisible }) => {
  const clickHandler = () => {
    searchBarVisible()
    setMenuOpen(!menuOpen)
  }
  return <>
    {Object.keys(menuLinks).map((key) => {
      return (
        <BasicLink key={key} to={menuLinks[key].to} onClick={() => setMenuOpen(false)} >
          <FooterMenuOption activeText={menuLinks[key].activeKeys.includes(history.location.pathname.split('/')[1])}>
            {menuLinks[key].icon}
            {menuLinks[key].text.split(' ')[0]}
          </FooterMenuOption>
        </BasicLink>
      )
    })}
    <FooterMenuOption onClick={clickHandler}>
      {menuOpen ? <X size={19} /> : <Menu size={19} />}
      More
    </FooterMenuOption>
  </>
}

export default function BottomNav({ searchBarVisible }) {
  const history = useHistory()
  const [menuOpen, setMenuOpen] = useState(false)

  // to hide the body scrollbar - otherwise two scrollbars
  useEffect(() => {
    document.documentElement.style.setProperty('overflow', menuOpen ? 'hidden' : 'auto');
  }, [menuOpen])

  return (
    <>
      <Container>
        <NavigationListTablet menuLinks={menuLinks} history={history} setMenuOpen={setMenuOpen} menuOpen={menuOpen} searchBarVisible={searchBarVisible} />
      </Container>
      {menuOpen && <MobileMenu setMenuOpen={setMenuOpen} />}
    </>
  )
}
